export function handleResponse(response) {
  return response
}

export function handleError(error) {
  return error?.response
}
